import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { ApContentService } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';

import { TokensBrowserService } from '../tokens-browser.service';

import content from './verify-pincode.content.json';

/**
 * @module VerifyPincodeModule
 * @ngdoc component
 * @name VerifyPincodeComponent
 */
@Component({
    selector: 'tokens-browser-verify-pincode',
    templateUrl: 'verify-pincode.component.html',
    standalone: false
})
export class VerifyPincodeComponent implements OnInit {
    @Input()
    public pincode: string;

    @Output()
    public verifyPincode: EventEmitter<string> = new EventEmitter();

    @Output()
    public back: EventEmitter<void> = new EventEmitter();

    public form: UntypedFormGroup;
    public buttonsDisabled: boolean;

    public errorMessage: ErrorMessages;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly tokensBrowserService: TokensBrowserService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.form = new UntypedFormGroup({
            verifyPincode: new UntypedFormControl('', [Validators.required, Validators.pattern(`^${this.pincode}$`)])
        });
        this.tokensBrowserService.setFocusOnActiveInput('tokens-browser-verify-pincode ap-pincode-input input');

        this.errorMessage = {
            required: this.contentService.get(`tokens.browser.verifyPincode.error.required`),
            pattern: this.contentService.get(`tokens.browser.verifyPincode.error.pattern`)
        };
    }

    public submit(): void {
        this.buttonsDisabled = true;
        if (this.form.valid) {
            this.verifyPincode.emit();
        } else {
            this.buttonsDisabled = false;
            Object.keys(this.form.controls).forEach((field) => {
                const control = this.form.get(field);
                control.markAsTouched();
                control.markAsDirty();
            });
        }
    }

    public goBack(): void {
        this.back.emit();
    }
}
